import * as S from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretLeft,
  faCaretRight,
  faEdit,
  faEye,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FieldDate } from "../FieldDate";
import { useState } from "react";

const CustomTableIonListado = ({
  metadataRegisters,
  data,
  page,
  setPage,
  listSize,
  setModalRequest,
  setSelected,
  actualizarSeleccionado,
  permissions,
}) => {
  const handleClickBotonComprometido = (row, modal) => {
    setSelected(row["ot"]);
    setModalRequest(modal);
  };

  const parseValue = (row, field) => {
    switch (field.tipo) {
       case "bool":
        const v = row[field.nombreCampo];
        return field.tipo === "bool" ? v == null ? "" : v ? "Sí" : "No": v ?? ""

      case "date":
        return (
          <FieldDate
            id={field.nombreCampo}
            value={row[field.nombreCampo]?.split("T")[0] || ""}
            readOnly={true}
          />
        )
      // TODO: esto podriamos llevar a un helper que formate
      case "currency":
        return row[field.nombreCampo].toLocaleString("es-ES", {
          style: "currency",
          currency: "EUR",
        });


      default:
        return row[field.nombreCampo];
    }
  };

  const marcarDesmarcarComprometido = (e) => {
    const { value, checked } = e.target;
    actualizarSeleccionado(value, checked);
  };

  return (
    <> 
      <S.ScrollContainer>
        <S.Table $colCount={metadataRegisters.length} >
          <S.ColGroup>
            {metadataRegisters.map((field) => (
              <S.Col key={field.id} />
            ))}
          </S.ColGroup>
          <S.Tr>
             <S.Th title="Seleccionar" $sticky $left={0}>
              <S.HeaderColumn></S.HeaderColumn>
            </S.Th>
            <S.Th title="Visualizar" $sticky $left={0}>
              <S.HeaderColumn>Visualizar</S.HeaderColumn>
            </S.Th>            

            <S.Th title={"Gestionar"}>
              <S.HeaderColumn>Gestionar</S.HeaderColumn>
            </S.Th>
            
            {metadataRegisters.map((field, index) => (
              <S.Th key={index} title={field.etiqueta}>
                <S.HeaderColumn>{field.etiqueta}</S.HeaderColumn>
              </S.Th>
            ))}          
          </S.Tr>
          {!!data?.length && (
            <>
              {data.map((row, index) => (
                <S.Tr key={index}>
                  <S.Td>
                    <input
                        id="checkComprometido"
                        type="checkbox"
                        value={row.ot}
                        checked={row.seleccionado ?? false}
                        onChange={marcarDesmarcarComprometido}
                      />
                  </S.Td>
                  
                  <S.Td>
                    <S.Buttons>
                      <button
                        onClick={() =>
                          handleClickBotonComprometido(
                            row,
                            "visualizarComprometido"
                          )
                        }
                        disabled={!permissions.IONComprometido?.Listar}
                      >
                        <FontAwesomeIcon icon={faEye} size="lg" />
                      </button>
                    </S.Buttons>
                  </S.Td>
                  
                  <S.Td key={"field.id"} title={null}>
                        <S.Buttons>
                          <button
                            onClick={() =>
                              handleClickBotonComprometido(row, "editarComprometido")
                            }
                            disabled={!permissions.IONComprometido?.Editar}
                          >
                            <FontAwesomeIcon icon={faEdit} size="lg" />
                          </button>
                          <button
                            onClick={() =>
                              handleClickBotonComprometido(
                                row,
                                "eliminarComprometido"
                              )
                            }
                            disabled={!permissions.IONComprometido?.Eliminar}
                          >
                            <FontAwesomeIcon icon={faTrash} size="lg" />
                          </button>
                        </S.Buttons>
                  </S.Td>

                  {metadataRegisters.map((field) => (
                    <S.Td
                      key={field.id}
                      title={row[field.nombreCampo]?.toString()}
                    >
                      {parseValue(row, field)}
                    </S.Td>
                  ))}
                
                </S.Tr>
              ))}
            </>
          )}
        </S.Table>
      </S.ScrollContainer>
      
      {!data?.length && (
        <S.EmptyRegs>
          <div>Sin registros</div>
        </S.EmptyRegs>
      )}

      {!!data.length && (
        <S.Pagination>
          <button
            onClick={() => setPage(page - 1)}
            disabled={page === 1 ? true : false}
          >
            <FontAwesomeIcon icon={faCaretLeft} size="lg" />
            <span>Anterior</span>
          </button>

          <span>Página: {page}</span>

          <button
            onClick={() => setPage(page + 1)}
            disabled={data.length < listSize}
          >
            <span>Siguiente</span>
            <FontAwesomeIcon icon={faCaretRight} size="lg" />
          </button>
        </S.Pagination>
      )}      
    </>
  );
};

export default CustomTableIonListado;
